/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import jwtDecode from 'jwt-decode';
import { string } from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {
    brandImagePaths,
} from './helpers/brandErrorPageHelpers';
import { getBrandIdByHostName } from '../../../../../state/ducks/App/App-Helpers';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'fixed',
        width: '100vw',
        height: '100vh',
        paddingLeft: '2em',
        paddingRight: '2em',
        boxSizing: 'border-box',
        '@media screen and (max-width: 600px)': {
            paddingLeft: '0.5em',
            paddingRight: '0.5em',
        },
    },
    title: {
        fontSize: '1.5em',
        fontWeight: 'bold',
    },
    logo: {
        display: 'block',
        margin: '1em auto 0em',
        height: '89px',
    },
    reloadButton: {
        display: 'block',
        margin: '2em auto',
        textTransform: 'capitalize',
        // use mui defualt colors if we cannot find in theme
        backgroundColor: theme.palette.colorPrimary,
        '&:hover': {
            backgroundColor: theme.palette.colorPrimary || false,
        },
    },
}));

export const ContactId = ({ className }) => {
    const JWT_PAYLOAD_KEY_1 = 'https://plants.com/';
    // Get Token from sessionStorage
    let contactId = 'NO_CONTACT_ID';

    if (typeof sessionStorage !== 'undefined') {
        const rootSessionStorage = JSON.parse(sessionStorage.getItem('persist:root'));
        if (rootSessionStorage && rootSessionStorage.member) {
            const memberObj = JSON.parse(rootSessionStorage.member);
            if (memberObj?.auth?.accessToken) {
                const decodeToken = jwtDecode(memberObj.auth.accessToken);
                const jwtPayload = decodeToken[JWT_PAYLOAD_KEY_1];
                contactId = jwtPayload?.contactId || 'NO_CONTACT_ID';
            }
        }
    }

    return (
        <div className={className || ''}>
            <b>Contact ID:</b>&nbsp;{`${contactId}`}
        </div>
    );
};

ContactId.propTypes = {
    className: string,
};

ContactId.defaultProps = {
    className: '',
};

const AppErrorBoundary = () => {
    const defaultHost = 'plants';
    let brandCode = getBrandIdByHostName(defaultHost);
    if (typeof window !== 'undefined') {
        const currentHost = window.location.hostname;
        brandCode = getBrandIdByHostName(currentHost) || brandCode;
    }
    const classes = useStyles({ brandCode });
    const imageUrl = brandImagePaths[brandCode].defaultImg;

    const handleReload = () => {
        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    return (
        <div className={classes.root}>
            <img src={imageUrl} alt="plants" className={classes.logo} />
            <Typography id="sorryPage" paragraph variant="h1" className={classes.title}>
                Sorry!
            </Typography>
            <Typography variant="body1">
                There was an unexpected problem.
            </Typography>
            <ContactId />
            <Button
                variant="contained"
                color="primary"
                className={classes.reloadButton}
                onClick={handleReload}
            >
                Try Again
            </Button>
        </div>
    );
};

export default AppErrorBoundary;
